import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import BannerButton from '../../components/banner-button.vue';

import global from '../../common/global';

import { colorBlock } from '../defaultSpacing';
import signLog from '@/components/sign-log';
import util from '@/common/util';

export default {
    i18next: {
        ns: 'md-cta'
    },
    data: function() {
        return {
            sizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 340,
                mobileHeight: 300
            },
            minHeight: '',
            col1Picture: {
                src: '',
                mobileSrc: ''
            },
            col2Picture: {
                src: '',
                mobileSrc: ''
            },
            col1Title: '',
            col1SubTitle: '',
            col2Title: '',
            col2SubTitle: '',
            col1ButtonAlign: 'center',
            col2ButtonAlign: 'center',
            col1Buttons: [],
            col2Buttons: [],
            ...colorBlock,
            showArrow: true,
            color: '#fff',
            textColor: '#000'
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) + 'px'
            );
        }
    },
    mounted() {
        this.currentWidth = window.innerWidth;
        this.calcStyle(true);
        global.resize(this.calcStyle);
    },
    methods: {
        calcStyle(flag) {
            if (
                flag !== true &&
                this.isMobile &&
                this.currentWidth &&
                this.currentWidth === window.innerWidth
            ) {
                return; 
            }
            console.log('calcStyle');
            this.currentWidth = window.innerWidth;
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            let minHeight = '';
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            const ele =
                this.$refs.content && this.$refs.content.$el
                    ? this.$refs.content.$el
                    : this.$refs.content;
            if (type === 'scale') {
                minHeight = (ele.offsetWidth * ratio) / 100 + 'px';
            } else if (type === 'fullScreen') {
                minHeight =
                    Math.max(window.innerHeight - this.$el.offsetTop, 500) +
                    'px';
            } else if (type === 'height') {
                minHeight = height + 'px';
            }
            this.minHeight = minHeight;
        },
        showRegisterPop(button) {
            let role = button?.registerRole || '';
            let tag = button?.tag || '';
            if (!this.user) {
                signLog.register({
                    role,
                    registerData: {
                        tag
                    }
                });
            } else {
                util.toast(this.$t('md-cta.youAreAlreadyLogged'), 2000);
            }
        }
    },
    unmounted() {
        global.resize(this.calcStyle, true);
    },
    components: {
        BannerButton
    }
};
